import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { setGlobal, getGlobal, addCallback } from 'reactn';
import { debounce } from './helpers';
var defaults = {
  KEY: '@reactn',
  whitelist: [],
  debounceDelay: 1000,
  debug: false,
  initialValue: {}
};
export var REHIDRATED_KEY = 'rehidrated';

var log = function log(method, payload) {
  console.log('reactn-persist: ', method, payload);
};

var rehidrate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var storage, key, initialValue, debug, persistedGlobalValue, persistedGlobal, global;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            storage = _ref.storage, key = _ref.key, initialValue = _ref.initialValue, debug = _ref.debug;
            _context.prev = 1;
            _context.next = 4;
            return storage.getItem(key);

          case 4:
            persistedGlobalValue = _context.sent;
            persistedGlobal = JSON.parse(persistedGlobalValue);
            global = getGlobal();
            setGlobal(_objectSpread({}, initialValue, {}, persistedGlobal, _defineProperty({}, REHIDRATED_KEY, true)));
            debug && log('rehidrate', {
              initial: _objectSpread({}, global),
              persisted: _objectSpread({}, persistedGlobal)
            });
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            setGlobal(_objectSpread({}, initialValue, _defineProperty({}, REHIDRATED_KEY, true)));
            debug && log('rehidrate', {
              error: _context.t0.message
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));

  return function rehidrate(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var parsePerisistableGlobal = function parsePerisistableGlobal(global, _ref3) {
  var whitelist = _ref3.whitelist;
  return Object.keys(global).reduce(function (persistedGlobal, key) {
    if (whitelist.includes(key)) {
      persistedGlobal[key] = global[key];
    }

    return persistedGlobal;
  }, Object.create(null));
};

var persist = function persist(_ref4) {
  var storage = _ref4.storage,
      key = _ref4.key,
      whitelist = _ref4.whitelist,
      debug = _ref4.debug;
  return function (global) {
    try {
      var persistedGlobal = whitelist.length ? parsePerisistableGlobal(global, {
        whitelist: whitelist
      }) : global;
      var persistedGlobalValue = JSON.stringify(persistedGlobal);
      storage.setItem(key, persistedGlobalValue);
      debug && log('persist', {
        key: key,
        value: persistedGlobalValue
      });
    } catch (error) {
      debug && log('persist', {
        error: error.message
      });
    }
  };
};

var init = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5) {
    var storage, _ref5$key, key, _ref5$whitelist, whitelist, _ref5$debounceDelay, debounceDelay, _ref5$debug, debug, _ref5$initialValue, initialValue, debouncedPersist;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            storage = _ref5.storage, _ref5$key = _ref5.key, key = _ref5$key === void 0 ? defaults.KEY : _ref5$key, _ref5$whitelist = _ref5.whitelist, whitelist = _ref5$whitelist === void 0 ? defaults.whitelist : _ref5$whitelist, _ref5$debounceDelay = _ref5.debounceDelay, debounceDelay = _ref5$debounceDelay === void 0 ? defaults.debounceDelay : _ref5$debounceDelay, _ref5$debug = _ref5.debug, debug = _ref5$debug === void 0 ? defaults.debug : _ref5$debug, _ref5$initialValue = _ref5.initialValue, initialValue = _ref5$initialValue === void 0 ? defaults.initialValue : _ref5$initialValue;
            _context2.prev = 1;
            _context2.next = 4;
            return rehidrate({
              storage: storage,
              key: key,
              initialValue: initialValue
            });

          case 4:
            debouncedPersist = debounce(persist({
              storage: storage,
              key: key,
              whitelist: whitelist
            }), debounceDelay);
            addCallback(debouncedPersist);
            debug && log('init', {
              success: true
            });
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            debug && log('init', {
              error: _context2.t0.message
            });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));

  return function init(_x2) {
    return _ref6.apply(this, arguments);
  };
}();

export default init;